export default __webpack_public_path__ + "fonts/368006_0_0.woff";